import React from "react";
import currency from "currency.js";
import PropTypes from 'prop-types';
import { helpers, Enums } from "@shared";

const EnrollmentSummary = ({ enrollment, invoice, done, modify, error, idProductType, account }) => {

    const {
        idPayor: idCurrentPayor
    } = account;

    const { sunboundTotal, subTotal, feeTotal, dueDate } = invoice;

    return (
        <div className="page-content-wrapper">
            <div className="flex flex-col p-3 w-full">
                <div className="flex flex-col gap-y-3">
                    <h1 className="page-header">Confirm payment plan</h1>
                    {
                        idProductType === Enums.ProductType.SunboundPay &&
                        < span className="page-subheader">By clicking <b>Confirm</b> you agree to have Sunbound cover your bill and to pay Sunbound back per the following</span>
                    }
                    {
                        idProductType !== Enums.ProductType.SunboundPay &&
                        < span className="h-1"></span>
                    }
                </div>
                <div className="flex flex-row justify-between pt-4 pb-2">
                    <span className="text-center font-bold text-2xl">Total Charges</span>
                    <span className="text-center text-2xl pr-6">{currency(sunboundTotal).format()}</span>
                </div>
                <div className="flex flex-col bg-sb-bg p-2 px-6 gap-y-2 rounded-xl">
                    <div className="flex flex-row">
                        <div className="w-2/3 font-bold">Community Charges</div>
                        <div className="w-1/3 text-end">{currency(subTotal).format()}</div>
                    </div>
                    {
                        idProductType === Enums.ProductType.SunboundPay &&
                        < div className="flex flex-row">
                            <div className="w-2/3 font-bold">Pay Over Time Fee</div>
                            <div className="w-1/3 text-end">{currency(feeTotal).format()}</div>
                        </div>
                    }
                </div>
                <div className="flex flex-row justify-between pt-6 pb-2">
                    <span className="text-center font-bold text-2xl">Payment Plan</span>
                    <button className="btn btn-outline-primary w-16 h-8 text-sm py-1 px-1 rounded" onClick={modify}>Edit</button>
                </div>
                <div className="flex flex-col bg-sb-bg  p-2 px-6  gap-y-3 rounded-xl">
                    <ul className="list-disc marker:text-header">
                        {
                            enrollment.map((p) => {
                                const { idPayor, payAmount, dueDay, fullName, email } = p;
                                const nameLabel = idPayor === idCurrentPayor ? `My Payment` : fullName;

                                const payorAmount = currency(payAmount);
                                return (
                                    <React.Fragment key={email}>
                                        <li>
                                            <div className="flex flex-row gap-x-3 text-2xl text-header">
                                                <span className="whitespace-nowrap ">{nameLabel}</span>
                                                <span>-</span>
                                                <span>{payorAmount.format()}</span>
                                            </div>
                                        </li>
                                        <div className="flex flex-col border-l-2 border-header my-3 pl-3 gap-y-1">
                                            <div className="border-right font-bold">{helpers.compoundDay(dueDate, dueDay).toFormat(`DDD`)}</div>
                                        </div>
                                    </React.Fragment>
                                );
                            })


                        }
                    </ul>
                </div>
                <div className="page-action">
                    <button className="btn btn-primary font-bold rounded-full " onClick={done}>Confirm</button>
                    {
                        error.hasFormError &&
                        <p className="text-red-400 pt-4">{error.formError}</p>
                    }
                </div>
            </div>
        </div >
    );
};

EnrollmentSummary.propTypes = {
    enrollment: PropTypes.array.isRequired,
    invoice: PropTypes.object.isRequired,
    done: PropTypes.func.isRequired,
    modify: PropTypes.func.isRequired,
    error: PropTypes.object,
    idProductType: PropTypes.number.isRequired,
    account: PropTypes.object.isRequired
};

export default EnrollmentSummary;
